// extracted by mini-css-extract-plugin
export var btnTxt = "motionbtn-module--btn-txt--7f8af";
export var container = "motionbtn-module--container--6822e";
export var noHover = "motionbtn-module--no-hover--7636e";
export var wrapper = "motionbtn-module--wrapper--cd133";